module.exports = __webpack_public_path__ + "img/bell.657fb160.png";